import { useContext, useState, useEffect } from "react";
import {
  Grid,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { useMutation } from "@apollo/client";
import DialogContent from "@mui/material/DialogContent";

// Import from project
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { UPDATE_CLASS_TYPE } from "../../Schema/Class";
import { DialogTitleComp } from "../../Utils/Component";

export default function UpdateType({
  open,
  editData,
  setRefetch,
  handleClose,
}) {
  const { setAlert, t } = useContext(AuthContext);
  const [type, setType] = useState(editData?.type || "direct");

  // console.log("type::", type);

  // useEffect(() => {
  //   if (editData?.type) {
  //     setType(editData.type);
  //   }
  // }, [editData, open]);

  const [updateClassType, { loading }] = useMutation(UPDATE_CLASS_TYPE, {
    onCompleted: ({ updateClassType }) => {
      if (updateClassType?.isSuccess === true) {
        setAlert(true, "success", updateClassType?.message);
        handleClose();
        if (typeof setRefetch === "function") setRefetch();
      } else {
        setAlert(true, "error", updateClassType?.message);
      }
    },
    onError: ({ message }) => {
      setAlert(true, "error", { messageEn: message, messageKh: message });
    },
  });

  const handleSubmit = () => {
    if (!editData?._id) return;

    updateClassType({
      variables: {
        id: editData._id,
        type: type,
      },
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="dialog-container"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitleComp
        title={t("modal_title_update_type")}
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <Grid container rowSpacing={2} columnSpacing={3}>
          <Grid item xs={12}>
            <Typography>
              {t("thead_do_you_want_to_completed_this_data")}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography className="class-name-field-title">
              {t("thead_type")}
            </Typography>
            <FormControl fullWidth size="small" className="text-field">
              <Select value={type} onChange={(e) => setType(e.target.value)}>
                <MenuItem value="direct">{t("direct")}</MenuItem>
                <MenuItem value="online">{t("online")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Button
              className="btn-create"
              fullWidth
              variant="contained"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                t("update")
              )}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
